import { render, staticRenderFns } from "./RiskConferenceWarningAlways.vue?vue&type=template&id=4b281d92&scoped=true"
import script from "./RiskConferenceWarningAlways.vue?vue&type=script&lang=js"
export * from "./RiskConferenceWarningAlways.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b281d92",
  null
  
)

export default component.exports